export default __webpack_public_path__ + "static/media/amasa-with-text.12129707.png";